import React from "react";

interface DownloadIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg";
}

export const DownloadIcon = ({
    className = "",
    color = "currentColor",
    size = "md",
}: DownloadIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",   // ~16x16px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
    };

    return (
        <div className="icon download-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                <path d="M12 4v11" />
                <path d="M7.4 10.4 12 15l4.6-4.6" />
                <path d="M4.6 19h14.8" />
            </svg>
        </div>
    );
};

export default DownloadIcon;
